import { isLoadCheckPassed } from '../components/LoadCheck';
import { productSizeCheck } from './CheckProductReady';
import ValidateValue from './ValidateValue';

function isFieldMissing(
  field,
  options,
  inputs,
  result,
  showAll,
  required = false
) {
  const isProduct = inputs.product_tbh?.length > 0;
  if (field === 'load_check') {
    return !isLoadCheckPassed(isProduct, result);
  }
  if (field === 'product_size') {
    return !productSizeCheck(isProduct, result);
  }

  const option = options.find((option) => option.field === field);

  if (
    !option ||
    option.input === 'checkbox' ||
    (!option.priced && showAll === 'priced')
  ) {
    return required;
  }

  const getValue = () => {
    if (option.calculated) {
      return result?.[option.field];
    }
    return option.value;
  };

  const value = getValue();

  const isEmptyValue = (val) =>
    [null, '', 'select an option', undefined].includes(val);

  const isMissingValue = (val) => {
    const { validateValue } = ValidateValue(option, val, inputs, result);
    return (option.required && isEmptyValue(val)) || !validateValue;
  };

  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    if (Object.keys(value).length === 0) return true;
    return Object.values(value).some(isMissingValue);
  } else {
    return isMissingValue(value);
  }
}

export default isFieldMissing;
